import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap';
import './externalNavbar.scss'
import { addUserRedirect } from '../../utility/commonFunctions'
import KeellsLogo from '../../assets/img/logo/KeellsWhiteLogo.png'
import { LOGIN_URL } from '../../utility/environment_config'

/*-- Imports for redux --*/
import { connect } from 'react-redux';

/*-- Map the redux states to props --*/
function mapStateToProps(state) {
    return {
        responsive: state.responsive
    }
};

/*-- Map the redux actions to props --*/
const mapDispatchToProps = {};

class ExternalNavbar extends Component {

    registerClick() {
        addUserRedirect(window.location.pathname, "/welcome/Registration")
    }
    loginClick() {
        addUserRedirect(window.location.pathname, "/welcome/Login")
    }
    render() {
        const { noLinks } = this.props;
        return (
            <div className='default-main-header'>
                <Col lg={{ span: 10, offset: 0 }} md={{ span: 10, offset: 1 }} sm={{ span: 8, offset: 1 }} xs={12} style={{ display: 'flex', justifyContent: "space-between" }}>
                    <a href={noLinks ? `${LOGIN_URL}/` : `${window.location.origin}/`}>
                        <img src={KeellsLogo} className="img-fluid" />
                    </a>
                    {noLinks ? null :
                        <div className="external-nav-button-holder">
                            <div className="external-nav-button" onClick={() => { this.registerClick() }}>Register</div>
                            <div className="nav-item-divider">|</div>
                            <div className="external-nav-button" onClick={() => { this.loginClick() }}>Login</div>
                        </div>
                    }
                </Col>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ExternalNavbar);